import React from "react";
import { Button } from "react-bootstrap";
import {
  ApproveIcon,
  CancelIcon,
  UnApproveIcon,
} from "../gui_components/Icons.js";
export class CustomerReturnModuleToolBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: this.props.pageTitle,
      isShowApproveButton: this.props.isShowApproveButton,
      isShowUnApproveButton: this.props.isShowUnApproveButton,
      isShowCancelButton: this.props.isShowCancelButton,
      isShowGenerateCreditMemoButton: this.props.isShowGenerateCreditMemoButton,
    };
  }
  cancelCustomerReturn = (e) => {
    if (e.detail === 1) this.props.cancelCustomerReturn();
  };
  approveCustomerReturn = (e) => {
    if (e.detail === 1) this.props.approveCustomerReturn();
  };
  unApproveCustomerReturn = (e) => {
    if (e.detail === 1) this.props.unApproveCustomerReturn();
  };
  generateCreditMemo = (e) => {
    if (e.detail === 1) this.props.generateCreditMemo();
  };
  render() {
    return (
      <>
        {this.props.isShowApproveButton && (
          <Button
            className="header_buttons secondary"
            size="sm"
            onClick={(e) => this.approveCustomerReturn(e)}
          >
            <ApproveIcon />
            Approve
          </Button>
        )}
        {this.props.isShowUnApproveButton && (
          <Button
            className="header_buttons secondary"
            size="sm"
            onClick={(e) => this.unApproveCustomerReturn(e)}
          >
            <UnApproveIcon />
            UnApprove
          </Button>
        )}
        {this.props.isShowCancelButton && (
          <Button
            className="header_buttons secondary"
            size="sm"
            onClick={(e) => this.cancelCustomerReturn(e)}
          >
            <CancelIcon />
            Cancel
          </Button>
        )}
        {this.props.isShowGenerateCreditMemoButton && (
          <Button
            className="header_buttons secondary"
            size="sm"
            onClick={(e) => this.generateCreditMemo(e)}
          >
            <CancelIcon />
            GenerateCreditMemo
          </Button>
        )}
      </>
    );
  }
}
